import UserStore from '@/store/user'
import ToastStore from '@/store/toasts'
import { Geolocation } from '@capacitor/geolocation'
import { Capacitor } from '@capacitor/core'
import { IUser, User } from '~/classes'

export const geolocationSet = async (
  coordinates: [number, number]
) => {
  const userStore = UserStore()
  
  await userStore.edit({
    coordinates
  }, {
    silent: true
  })

  return true
}

export const geolocationGet = async (
  options?: PositionOptions & {
    isSilent?: boolean
  }
) => {
  const toastsStore = ToastStore()

  try {
    const permissions = await Geolocation.checkPermissions()

    if (permissions.location !== 'granted') {
      if (Capacitor.isNativePlatform()) {
        const request = await Geolocation.requestPermissions()

        if (request.location !== 'granted' && options?.isSilent !== true) {
          toastsStore.add({
            content: useNuxtApp().$i18n.t('errors.perm'),
            type: 'failure'
          })

          throw new Error('Permission denied')
        }
      }
    }

    const response = await Geolocation.getCurrentPosition(options)

    return [
      response.coords.longitude,
      response.coords.latitude
    ] as [number, number]
  } catch (error) {
    if (options?.isSilent !== true) console.error(error)
    
    return null
  }
}

export const geolocationUpdate = async (
  user: User
) => {
  const coordinates = await geolocationGet({
    enableHighAccuracy: true,
    timeout: 15000,
    maximumAge: 30000,
    isSilent: true
  })

  if (!coordinates) return false
  
  if (user.coordinates?.[0] === coordinates[0] && user.coordinates?.[1] === coordinates[1]) return false

  return await geolocationSet(coordinates)
}

export const geolocationCanEnable = async () => {
  if (!Capacitor.isPluginAvailable('Geolocation')) return false

  return true
}

export const distanceGet = (coords1: [ number, number ], coords2: [ number, number ]) => {
  function deg2rad(deg: number) {
    return deg * (Math.PI/180)
  }

  var R = 6371
  var dLat = deg2rad(coords2[0]-coords1[0])
  var dLon = deg2rad(coords2[1]-coords1[1]);
  var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(deg2rad(coords1[0])) * Math.cos(deg2rad(coords1[0])) *  Math.sin(dLon/2) * Math.sin(dLon/2)

  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  var d = R * c

  return d;
}